import React, { useMemo } from 'react'
import { BrandMapping } from '@nsw-paginas-deslogadas/assets'
import { useAppContext } from '@nsw-paginas-deslogadas/store'
import { FoldAboutNav, FoldFaq, FoldPagePresentationBrand, Swipper } from '@nsw-paginas-deslogadas/components'

const LandingPage: React.FC = () => {
    const { brand } = useAppContext()
    const brandMap = BrandMapping[brand.mappingId]

    const questionsByBrand = useMemo(() => {
        return BrandMapping[brand.mappingId].questions
    }, [brand.mappingId])

    return (
        <>
            <FoldPagePresentationBrand />
            <Swipper />
            <FoldFaq
                examLink={brandMap.buttons.faq.exams}
                questions={questionsByBrand}
                vaccineActive={brandMap.buttons.faq.vaccineActive}
                vaccineLink={brandMap.buttons.faq.vaccines}
            />
            <FoldAboutNav />
        </>
    )
}

export default LandingPage
